module.exports = __webpack_public_path__ + "img/logo-bishui.00117903.jpg";